import { Directive, ElementRef, EventEmitter, HostListener, Input, Output, Renderer2 } from '@angular/core';
import { GetDefinedCardServiceCardModel } from '../models/get-defined-card-models';

@Directive({
  selector: '[appCreditCardSelector]'
})
export class CreditCardSelectorDirective {
  @Input() index!:number;
  @Input() selectedIndex!:number;
  @Input() card!:GetDefinedCardServiceCardModel;

  @Output() selectedCardChanged = new EventEmitter();

  constructor(
    private renderer:Renderer2,
    private elementRef:ElementRef
  ) { }

  @HostListener('click') onClick(){
    this.selectedCardChanged.emit({card:this.card, index:this.index});
  }

  ngOnChanges(){
    if(this.index === this.selectedIndex){
      this.renderer.setStyle(this.elementRef.nativeElement, 'transform', 'scale(1.1)')
      this.renderer.setStyle(this.elementRef.nativeElement, 'box-shadow', 'rgb(226 229 235) 0px 0px 20px 20px');
      this.renderer.setStyle(this.elementRef.nativeElement, 'color', '#6283ba');
      this.selectedCardChanged.emit({card:this.card, index:this.index});
    }else{
      this.renderer.removeStyle(this.elementRef.nativeElement, 'box-shadow');
      this.renderer.removeStyle(this.elementRef.nativeElement, 'color');
      this.renderer.removeStyle(this.elementRef.nativeElement, 'transform');
    }
  }
}
